import { useNavigate } from "react-router-dom"
import "../styles/portal/Implementos.css"
import Select from "react-select";
import Botao from "../utils/Botao";
import EmConstrucao from "../EmConstrucao";

function Implementos() {
    const navigate = useNavigate();
    const handleOnClickVoltar = () => {
        navigate("/portal/home");
    };
    const handleChange = (selectedItems) => {
        console.log(selectedItems);
    }
    const handleOnClickImplemento = () => {
        navigate("/portal/implemento-detalhe");
    }
    const options = [
        {value: "xxx", label: "tablet01 (id:xxxx)"},
        {value: "yyy", label: "tablet02 (id:yyy)"},
        {value: "zzz", label: "tablet03 (id:zzz)"}
    ];
    const implementos = [
        {
            "implementoID": "ccc",
            "nome": "Implemento1"
        },
        {
            "implementoID": "ddd",
            "nome": "Implemento2"
        },
    ];
    return (
        <div className="implementos-container">
            <div className="implementos-tittle-container">
                {/* <button onClick={() => handleOnClickVoltar()}>Voltar</button> */}
                <Botao handleOnClick={() => handleOnClickVoltar()} estilo={{"width": "100px"}}>Voltar</Botao>
                <div className="tittle">Meus Implementos</div>
            </div>
            <EmConstrucao />
            {/* <div className="implementos-content-container">
                <div className="implementos-filter-container">
                    <div className="trabalhos-content-filter-dropdown">
                        <h3>Device:</h3>
                        <Select options={options} onChange={handleChange} />
                    </div>
                    <div className="trabalhos-content-filter-filtrarbtn">
                        <button>Filtrar</button>
                    </div>
                </div>
                <div className="implementos-lista-container">
                    {implementos.map((implemento) => (
                        <div className="implementos-lista-implemento" key={implemento.implementoID} onClick={() => handleOnClickImplemento()}>
                        <p>{implemento.nome}</p>
                    </div>
                    ))}                    
                </div>
            </div> */}
        </div>
    )
}

export default Implementos
